import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { CheckbookGroupTemplateState } from '../reducers/checkbook-group-template.reducer';
import * as selectors from '../selectors/checkbook-group-template.selectors';

@Injectable()
export class CheckbookGroupTemplateFacadeService extends FacadeService {
  constructor(public override store: Store<CheckbookGroupTemplateState>) {
    super(store);
  }

  // OBSERVABLES

  displayedColumns$ = this.storeSelect(selectors.getCheckbookGroupTemplateDisplayedColumns);
  displayedColumnKeys$ = this.storeSelect(selectors.getCheckbookGroupTemplateDisplayedColumnKeys);
  code$ = this.storeSelect(selectors.getCode);
  selectedTypeId$ = this.storeSelect(selectors.getSelectedType);
  prefix$ = this.storeSelect(selectors.getPrefix);
  remarks$ = this.storeSelect(selectors.getRemarks);
  checkbookTypes$ = this.storeSelect(selectors.getCheckbookTypes);
  checkbookGroupTemplateData$ = this.storeSelect(selectors.getCheckbookGroupTemplateData);
  couponSet$ = this.storeSelect(selectors.getCouponSet);
  excludedGroupTemplateColKeys$ = this.storeSelect(selectors.getExcludedGroupTemplateColKeys);
  couponSetId$ = this.storeSelect(selectors.getCheckbookGroupTemplateState);
  couponBatchNumber$ = this.storeSelect(selectors.getCouponBatchNumber);
  bookCouponPrefix$ = this.storeSelect(selectors.getCheckbookPrefix);
  checkbookGroupTemplateDataAreValid$ = this.storeSelect(
    selectors.getCheckbookGroupTemplateDataAreValid,
  );
  showCodeErrorMsg$ = this.storeSelect(selectors.getShowCodeErrorMsg);
  showSelectedTypeErrorMsg$ = this.storeSelect(selectors.getShowSelectedTypeErrorMsg);
  showPrefixErrorMsg$ = this.storeSelect(selectors.getShowPrefixErrorMsg);
  showCouponSetErrorMsg$ = this.storeSelect(selectors.getShowCouponSetErrorMsg);
  showCouponBatchNumberErrorMsg$ = this.storeSelect(selectors.getBatchNumberErrorMsg);
  showCheckbookPrefixErrorMsg$ = this.storeSelect(selectors.getCheckbookPrefixErrorMsg);
  showDeleteAllBtn$ = this.storeSelect(selectors.getShowDeleteAllBtn);
  showAddLineBtn$ = this.storeSelect(selectors.getShowAddLineBtn);
  isCreateNewGroupTemplate$ = this.storeSelect(selectors.getIsCreateNewGroupTemplate);
  isUpdateGroupTemplate$ = this.storeSelect(selectors.getIsUpdateGroupTemplate);
  showCreateNewBtn$ = this.storeSelect(selectors.getShowCreateNewBtn);
  showPrefixPatternError$ = this.storeSelect(selectors.getShowPrefixPatternErrorMsg);
  inactive$ = this.storeSelect(selectors.getInactive);
  bookCouponGroupTemplateId$ = this.storeSelect(selectors.getBookCouponGroupTemplateId);
  showCodeValidationErrorMessage$ = this.storeSelect(selectors.getCodeValidationStatus);

  // OBSERVABLE'S VALUES

  get code() {
    return this.storeSnapshot(this.code$);
  }

  get selectedTypeId() {
    return this.storeSnapshot(this.selectedTypeId$);
  }

  get prefix() {
    return this.storeSnapshot(this.prefix$);
  }

  get remarks() {
    return this.storeSnapshot(this.remarks$);
  }

  get checkbookTypes() {
    return this.storeSnapshot(this.checkbookTypes$);
  }

  get checkbookGroupTemplateData() {
    return this.storeSnapshot(this.checkbookGroupTemplateData$);
  }

  get couponSet() {
    return this.storeSnapshot(this.couponSet$);
  }

  get excludedGroupTemplateColKeys() {
    return this.storeSnapshot(this.excludedGroupTemplateColKeys$);
  }

  get couponSetId() {
    return this.storeSnapshot(this.couponSetId$);
  }

  get couponBatchNumber() {
    return this.storeSnapshot(this.couponBatchNumber$);
  }

  get bookCouponPrefix() {
    return this.storeSnapshot(this.bookCouponPrefix$);
  }

  get checkbookGroupTemplateDataAreValid() {
    return this.storeSnapshot(this.checkbookGroupTemplateDataAreValid$);
  }

  get showCodeErrorMsg() {
    return this.storeSnapshot(this.showCodeErrorMsg$);
  }

  get showSelectedTypeErrorMsg() {
    return this.storeSnapshot(this.showSelectedTypeErrorMsg$);
  }

  get showPrefixErrorMsg() {
    return this.storeSnapshot(this.showPrefixErrorMsg$);
  }

  get showCouponSetErrorMsg() {
    return this.storeSnapshot(this.showCouponSetErrorMsg$);
  }

  get showCouponBatchNumberErrorMsg() {
    return this.storeSnapshot(this.showCouponBatchNumberErrorMsg$);
  }

  get showCheckbookPrefixErrorMsg() {
    return this.storeSnapshot(this.showCheckbookPrefixErrorMsg$);
  }

  get isCreateNewGroupTemplate() {
    return this.storeSnapshot(this.isCreateNewGroupTemplate$);
  }

  get isUpdateGroupTemplate() {
    return this.storeSnapshot(this.isUpdateGroupTemplate$);
  }

  get showCreateNewBtn() {
    return this.storeSnapshot(this.showCreateNewBtn$);
  }

  get inactive() {
    return this.storeSnapshot(this.inactive$);
  }

  get bookCouponGroupTemplateId() {
    return this.storeSnapshot(this.bookCouponGroupTemplateId$);
  }
}
